import { SimpleGrid, useBreakpointValue } from '@chakra-ui/react'
import type { Agenda } from '@/services/agendas'
import type { ViewMode } from '../types'
import AgendaCard from './AgendaCard'

type AgendaListProps = {
  agendas: Agenda[]
  view: ViewMode
}

const AgendaList = ({ agendas, view }: AgendaListProps) => {
  const effectiveView = useBreakpointValue<ViewMode>({ base: 'list', md: view }) ?? 'list'

  const columns = effectiveView === 'grid'
    ? { base: 1, md: 2, lg: 3, xl: 4 }
    : { base: 1, md: 1 }

  return (
    <SimpleGrid columns={columns} gap="4">
      {agendas.map((agenda) => (
        <AgendaCard key={agenda.id} agenda={agenda} view={effectiveView} />
      ))}
    </SimpleGrid>
  )
}

export default AgendaList
